var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',_vm._b({staticClass:"pa-0"},'v-col',{ ..._vm.containerProps, ..._vm.containerOptions },false))
}
var staticRenderFns = []

export { render, staticRenderFns }